import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useMileageUsableInfoService = () => {
  const param = useCatalogProductIdParams();
  const { shop } = usePdpBaseInfo(param);

  const sellerSpecificUseMileageRate = (shop.usable_mileage?.seller_specific_use_mileage_rate_bp ?? 0) / 100;
  const isHide = !shop.usable_mileage || !sellerSpecificUseMileageRate;

  return {
    isHide,
    shopName: shop.name,
    sellerSpecificUseMileageRate,
    defaultUseMileageRate: (shop.usable_mileage?.default_use_mileage_rate_bp ?? 0) / 100,
    totalUseMileageRate: (shop.usable_mileage?.total_use_mileage_rate_bp ?? 0) / 100,
  };
};
